import { useEffect } from "react";
import { motion } from "framer-motion";
import JoinForm from "../components/JoinForm";
import { Reveal } from "../components/Motion";

const BG = "https://static.prod-images.emergentagent.com/jobs/9f155735-a3e2-49f2-ade7-372db22ee705/images/58ccf43e68184f7a2c6cf7cc31306c1bff73efd8035337701009a64a0c9f26b6.jpeg";

export default function Join() {
  useEffect(() => {
    document.title = "Join — Motion & Meaning";
  }, []);

  return (
    <section className="relative min-h-screen flex items-center overflow-hidden" data-testid="join-page">
      <motion.img
        src={BG}
        alt=""
        aria-hidden="true"
        className="absolute inset-0 w-full h-full object-cover opacity-30"
        initial={{ scale: 1.1 }}
        animate={{ scale: 1 }}
        transition={{ duration: 6, ease: "easeOut" }}
      />
      <div className="absolute inset-0 bg-gradient-to-r from-[#050505] via-[#050505]/85 to-[#050505]/40" />
      <div className="mm-vignette" />

      <div className="relative z-10 max-w-[1440px] mx-auto px-6 md:px-12 w-full grid grid-cols-1 md:grid-cols-2 gap-16 items-center pt-32 pb-24">
        <div>
          <Reveal>
            <p className="font-mono text-[11px] tracking-[0.4em] text-gold mb-6">THE INNER CIRCLE</p>
            <h1 className="font-serif text-6xl sm:text-7xl lg:text-8xl font-light leading-[0.9] text-white">
              Enter the<br /><span className="italic">Inner Circle</span>
            </h1>
            <p className="text-white/60 leading-relaxed mt-8 max-w-md">
              Be the first to know when new dimensions open. Early access to releases, visuals and
              limited physical editions — including what lies behind Dimension V.
            </p>
          </Reveal>
        </div>

        <Reveal delay={0.2} className="flex md:justify-end">
          <JoinForm />
        </Reveal>
      </div>
    </section>
  );
}
